/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./api/QueryProviderAPI',
	'./api/QueryModifierAPI',
	'underscore'
], (APIFactory, QueryProviderAPI, QueryModifierAPI, _) => {

	class DetailQueryProvider {
		constructor(options) {
			const features = options && options.features;
			if (features) {
				this._mainProvider = features.QueryProvider;
				this._mainModifier = features.QueryModifier;
			}

			const queryExecution = features && features.DataQueryExecution;
			if (queryExecution) {
				queryExecution.registerQueryProvider(this.getAPI());
				queryExecution.registerQueryModifier(this.getAPI());
			}
		}

		getAPI() {
			if (!this.api) {
				this.api = APIFactory.createAPI(this, [QueryProviderAPI, QueryModifierAPI]);
			}
			return this.api;
		}

		getType() {
			return 'detail';
		}

		getQuerySpecList() {
			const querySpecList = this._mainProvider && this._mainProvider.getQuerySpecList();
			return _.chain(querySpecList)
			// apply details of the main query (ie. filter out minmax query)
				.filter(entry => {
					return entry.type === 'main';
				})
			// update the query spec type in order to request disaggregated detail result
				.map(entry => {
					_.extend(entry.spec, {
						type: 'detail'
					});
					return entry;
				})
				.value();
		}

		modifyQuerySpecList(specList) {
			return this._mainModifier && this._mainModifier.modifyQuerySpecList(specList);
		}
	}
	return DetailQueryProvider;
});
